(function (root, factory) {
  'use strict';
  var progress = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = progress;
  else if (root) root.WTXFirstOrderProgress = progress;
}(typeof window !== 'undefined' ? window : null, function (root) {
  'use strict';

  var KEY = 'wtx_first_order_progress_v1';
  var VERSION = 1;
  var TTL = 2 * 60 * 60 * 1000;
  var MAX_BYTES = 20 * 1024;
  var enumFields = {
    goal: ['', 'routine', 'confidence', 'budget', 'training'],
    protein: ['', 'chicken', 'beef', 'both', 'other'],
    labelConfirmed: ['', 'yes', 'unsure'],
    health: ['', 'routine', 'review'],
    plan: ['', 'yes', 'no', 'estimate', 'help'],
    method: ['', 'pickup', 'local', 'shipping'],
    days: ['14', '30', '60', '90'],
    packSize: ['small', 'value'],
    split: ['25', '50', '75'],
    reviewMode: ['', 'guided', 'shopping'],
    horizonMode: ['', 'duration', 'cases']
  };
  var restrictionKinds = ['ingredient', 'prescribed', 'symptoms', 'weight', 'other'];
  var proteins = ['chicken', 'beef', 'fish', 'pork', 'duck', 'rabbit', 'turkey', 'lamb', 'egg', 'other'];
  var interests = ['joint', 'coat', 'gut', 'training', 'chewing'];
  var own = function (value, key) { return Object.prototype.hasOwnProperty.call(value, key); };

  function dataObject(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
    var prototype = Object.getPrototypeOf(value);
    if (prototype !== Object.prototype && prototype !== null) return false;
    if (Object.getOwnPropertySymbols(value).length) return false;
    return Object.keys(value).every(function (key) {
      return !['__proto__', 'constructor', 'prototype'].includes(key) && own(Object.getOwnPropertyDescriptor(value, key), 'value');
    });
  }

  function dataArray(value, maximum) {
    if (!Array.isArray(value) || Object.getPrototypeOf(value) !== Array.prototype || value.length > maximum || Object.getOwnPropertySymbols(value).length) return false;
    if (Object.keys(value).length !== value.length) return false;
    for (var i = 0; i < value.length; i += 1) {
      var descriptor = Object.getOwnPropertyDescriptor(value, String(i));
      if (!descriptor || !own(descriptor, 'value')) return false;
    }
    return true;
  }

  function string(value, maximum) {
    return typeof value === 'string' && value.length <= maximum && !/[\u0000-\u0008\u000b\u000c\u000e-\u001f]/.test(value);
  }

  function id(value) {
    if (typeof value === 'string' && (!/^\d+$/.test(value) || value.length > 16)) return null;
    if (typeof value !== 'string' && typeof value !== 'number') return null;
    var number = Number(value);
    return Number.isSafeInteger(number) && number > 0 ? number : null;
  }

  function numericText(value, maximum, whole) {
    if (value === '') return '';
    if (typeof value === 'number' && Number.isFinite(value)) value = String(value);
    if (typeof value !== 'string' || value.length > 20 || !/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(value)) return null;
    var number = Number(value);
    if (!Number.isFinite(number) || number < 0 || number > maximum || whole && !Number.isSafeInteger(number)) return null;
    return value;
  }

  function chooseList(value, maximum, choices, identifiers) {
    if (!dataArray(value, maximum)) return null;
    var output = [];
    for (var i = 0; i < value.length; i += 1) {
      var item = identifiers ? id(value[i]) : value[i];
      if (identifiers ? item === null : !choices.includes(item)) return null;
      if (output.includes(item)) return null;
      output.push(item);
    }
    return output;
  }

  function dogs(value) {
    if (!dataArray(value, 4)) return null;
    var output = [];
    for (var i = 0; i < value.length; i += 1) {
      var dog = value[i];
      if (!dataObject(dog)) return null;
      var next = {};
      if (own(dog, 'name')) {
        if (!string(dog.name, 80)) return null;
        next.name = dog.name;
      }
      var enums = {stage: ['', 'adult', 'puppy', 'senior', 'pregnant'], unit: ['', 'oz', 'lb'], condition: ['', 'lean', 'ideal', 'heavy', 'change', 'unsure'], activity: ['', 'usual', 'working', 'unsure']};
      for (var key of Object.keys(enums)) {
        if (!own(dog, key)) continue;
        if (!enums[key].includes(dog[key])) return null;
        next[key] = dog[key];
      }
      var amounts = {amount: 1600, weightLb: 1000, expectedAdultLb: 1000, ageMonths: 360};
      for (var amount of Object.keys(amounts)) {
        if (!own(dog, amount)) continue;
        var checked = numericText(dog[amount], amounts[amount], false);
        if (checked === null) return null;
        next[amount] = checked;
      }
      output.push(next);
    }
    return output;
  }

  function cases(value) {
    if (!dataObject(value) || Object.keys(value).length > 2) return null;
    var output = {};
    for (var key of Object.keys(value)) {
      var productId = id(key);
      var choice = value[key];
      if (!productId || own(output, String(productId)) || !dataObject(choice)) return null;
      var variantId = id(choice.variantId);
      var quantity = numericText(choice.quantity, 99, true);
      if (!variantId || quantity === null || quantity === '' || Number(quantity) < 1 ||
          own(choice, 'furAck') && typeof choice.furAck !== 'boolean') return null;
      output[String(productId)] = {variantId: String(variantId), quantity: quantity, furAck: choice.furAck === true};
    }
    return output;
  }

  function addonVariants(value) {
    if (!dataObject(value) || Object.keys(value).length > 3) return null;
    var output = {};
    for (var key of Object.keys(value)) {
      var productId = id(key);
      var variantId = id(value[key]);
      if (!productId || !variantId || own(output, String(productId))) return null;
      output[String(productId)] = String(variantId);
    }
    return output;
  }

  function manualLines(value) {
    if (!dataArray(value, 10)) return null;
    var output = [];
    var products = [];
    var variants = [];
    for (var i = 0; i < value.length; i += 1) {
      var line = value[i];
      if (!dataObject(line)) return null;
      var productId = id(line.productId);
      var variantId = id(line.variantId);
      if (!productId || !variantId || variants.includes(variantId) ||
          !Number.isSafeInteger(line.quantity) || line.quantity < 1 || line.quantity > 99 ||
          typeof line.lb !== 'number' || !Number.isFinite(line.lb) || line.lb <= 0 || line.lb > 1000) return null;
      if (!products.includes(productId)) products.push(productId);
      if (products.length > 2) return null;
      variants.push(variantId);
      output.push({productId: productId, variantId: variantId, quantity: line.quantity, lb: line.lb});
    }
    return output;
  }

  function sanitizeState(state) {
    if (!dataObject(state)) return null;
    var output = {};
    for (var key of Object.keys(enumFields)) {
      if (!own(state, key)) continue;
      if (!enumFields[key].includes(state[key])) return null;
      output[key] = state[key];
    }
    // Published stop names can change. Persist the preference, never route eligibility.
    // The order flow must still select and freshly validate a published route date.
    for (var area of ['localArea', 'pickupStop']) {
      if (!own(state, area)) continue;
      var name = state[area];
      if (typeof name !== 'string' || name.length > 350 ||
          /[\u0000-\u001f\u007f-\u009f]/.test(name) || name !== '' && !name.trim()) return null;
      output[area] = name;
    }
    var booleans = ['proposalManual', 'foodEditorOpen', 'feedingPlanConfirmed', 'labelConfirmedByPhoto'];
    for (var flag of booleans) {
      if (!own(state, flag)) continue;
      if (typeof state[flag] !== 'boolean') return null;
      output[flag] = state[flag];
    }
    var texts = {restrictionNotes: 1000, labelText: 3000};
    for (var text of Object.keys(texts)) {
      if (!own(state, text)) continue;
      if (!string(state[text], texts[text])) return null;
      output[text] = state[text];
    }
    var lists = {
      selected: [2, null, true], addons: [3, null, true],
      interests: [5, interests, false], restrictionKinds: [5, restrictionKinds, false], avoidProteins: [10, proteins, false]
    };
    for (var list of Object.keys(lists)) {
      if (!own(state, list)) continue;
      var options = lists[list];
      var result = chooseList(state[list], options[0], options[1], options[2]);
      if (result === null) return null;
      output[list] = result;
    }
    var objects = {dogs: dogs, cases: cases, addonVariants: addonVariants, addonPlans: addonVariants, manualLines: manualLines};
    for (var field of Object.keys(objects)) {
      if (!own(state, field)) continue;
      var checked = objects[field](state[field]);
      if (checked === null) return null;
      output[field] = checked;
    }
    output.freezer = false;
    output.addonAcks = {};
    output.reviewRecipeConfirmed = false;
    output.proposalKey = '';
    output.proposalReason = '';
    output.proposalNotice = '';
    return output;
  }

  function snapshot(value) {
    if (!dataObject(value) || !Number.isSafeInteger(value.step) || value.step < 0 || value.step > 5 || typeof value.gate !== 'boolean') return null;
    var state = sanitizeState(value.state);
    return state ? {state: state, step: value.step, gate: value.gate} : null;
  }

  function byteLength(value) {
    var count = 0;
    for (var i = 0; i < value.length; i += 1) {
      var code = value.charCodeAt(i);
      if (code < 128) count += 1;
      else if (code < 2048) count += 2;
      else if (code >= 0xd800 && code <= 0xdbff && i + 1 < value.length && value.charCodeAt(i + 1) >= 0xdc00 && value.charCodeAt(i + 1) <= 0xdfff) {count += 4; i += 1;}
      else count += 3;
    }
    return count;
  }

  function bounded(raw) {
    return typeof raw === 'string' && raw.length * 2 <= MAX_BYTES && byteLength(raw) <= MAX_BYTES;
  }

  function create(storage, now) {
    var clock = typeof now === 'function' ? now : Date.now;
    function time() {
      var value = clock();
      return Number.isSafeInteger(value) && value >= 0 && value <= Number.MAX_SAFE_INTEGER - TTL ? value : null;
    }
    function save(value) {
      try {
        var safe = snapshot(value);
        if (!safe) return {ok: false, error: 'invalid_snapshot'};
        var savedAt = time();
        if (savedAt === null) return {ok: false, error: 'invalid_clock'};
        var expiresAt = savedAt + TTL;
        var raw = JSON.stringify({version: VERSION, savedAt: savedAt, expiresAt: expiresAt, snapshot: safe});
        if (!bounded(raw)) return {ok: false, error: 'too_large'};
        storage.setItem(KEY, raw);
        if (storage.getItem(KEY) !== raw) return {ok: false, error: 'storage_write_failed'};
        return {ok: true, savedAt: savedAt, expiresAt: expiresAt};
      } catch (_) {
        return {ok: false, error: 'storage_unavailable'};
      }
    }
    function read() {
      try {
        var raw = storage.getItem(KEY);
        if (raw === null) return {ok: false, error: 'missing'};
        if (!bounded(raw)) return {ok: false, error: 'too_large'};
        var record;
        try {record = JSON.parse(raw);} catch (_) {return {ok: false, error: 'invalid_record'};}
        if (!dataObject(record) || record.version !== VERSION || !Number.isSafeInteger(record.savedAt) || record.savedAt < 0 ||
            !Number.isSafeInteger(record.expiresAt) || record.expiresAt !== record.savedAt + TTL) return {ok: false, error: 'invalid_record'};
        var current = time();
        if (current === null) return {ok: false, error: 'invalid_clock'};
        if (current < record.savedAt) return {ok: false, error: 'invalid_record'};
        if (current >= record.expiresAt) return {ok: false, error: 'expired'};
        var safe = snapshot(record.snapshot);
        if (!safe) return {ok: false, error: 'invalid_record'};
        return {ok: true, snapshot: safe, savedAt: record.savedAt, expiresAt: record.expiresAt};
      } catch (_) {
        return {ok: false, error: 'storage_unavailable'};
      }
    }
    function clear() {
      try {
        storage.removeItem(KEY);
        return storage.getItem(KEY) === null ? {ok: true} : {ok: false, error: 'storage_clear_failed'};
      } catch (_) {
        return {ok: false, error: 'storage_unavailable'};
      }
    }
    return Object.freeze({save: save, read: read, clear: clear});
  }

  var browserStorage = {
    getItem: function (key) {return root.sessionStorage.getItem(key);},
    setItem: function (key, value) {root.sessionStorage.setItem(key, value);},
    removeItem: function (key) {root.sessionStorage.removeItem(key);}
  };
  var instance = create(browserStorage);
  return Object.freeze({
    create: create, save: instance.save, read: instance.read, clear: instance.clear,
    key: KEY, version: VERSION, ttlMs: TTL, maxBytes: MAX_BYTES
  });
}));
